import { mapActions, mapGetters, mapState } from 'vuex';
import purchaseOfferSushi from '@/components/purchase/sushi/purchase-offer-sushi/purchase-offer-sushi';
import marketCharts from '@/components/market/market-detail-charts/market-detail-charts.vue';
import purchaseTradeTypeSwitcherSushi from '@/components/purchase/sushi/purchase-trade-type-switcher-sushi/purchase-trade-type-switcher-sushi.vue';
import buttonPrice from '@/components/market/v2/button-price/button-price.vue';
import marketDisabledOutcomeV2
  from '@/components/market/v2/market-disabled-outcome-v2/market-disabled-outcome-v2.vue';
import purchaseExtendedBetslip
  from '@/components/purchase/sushi/purchase-extended-betslip/purchase-extended-betslip.vue';
import bottomMarketLinksWidget from '@/components/purchase/sushi/bottom-market-links-widget/bottom-market-links-widget.vue';
import bottomMarketLinksOverlay from '@/components/purchase/sushi/bottom-market-links-overlay/bottom-market-links-overlay.vue';
import bottomBetslipShortcutWidget
  from '@/components/purchase/sushi/bottom-betslip-shortcut-widget/bottom-betslip-shortcut-widget.vue'
import { BOTTOM_WIDGET_FOOTER_MODES } from '@/store/modules/trade';
import { NAVIGATION_TABS } from '@/components/pages/page-market-detail-sushi/page-market-detail-sushi';
import { lockScroll, unlockScroll } from '@/utils/helpers';


export default {
  mixins: [
    purchaseOfferSushi,
  ],
  props: {
    navigatedFromContractsSection: {
      type: Boolean,
      default: false,
    },
    showOwnershipAndOrdersBar: {
      type: Boolean,
      default: false,
    },
    selectedSection: {
      type: String,
      required: false,
      default: NAVIGATION_TABS.CONTRACTS,
    },
  },
  data() {
    return {
      BOTTOM_WIDGET_FOOTER_MODES,
      visible: false,
      isAtBottom: false,
      extDragStartY: 0,
      extDragAtTop: false,
    };
  },
  components: {
    marketDisabledOutcomeV2,
    buttonPrice,
    marketCharts,
    purchaseTradeTypeSwitcherSushi,
    purchaseExtendedBetslip,
    bottomMarketLinksWidget,
    bottomMarketLinksOverlay,
    bottomBetslipShortcutWidget,
  },
  computed: {
    ...mapGetters('user', ['isLoggedIn']),
    ...mapGetters('app', ['isLayoutMobile', 'isLayoutDesktop', 'isTradingEnabled']),
    ...mapState('trade', [
      'tradeOptions', 'tradeOperationToggle', 'isInConfirmationMode',
      'bottomBetslipExtended', 'bottomWidgetFooterMode', 'bottomWidgetFooterModeContractsSection',
    ]),
    ...mapState('user', ['status']),
    isHidden() {
      const dontHide = [BOTTOM_WIDGET_FOOTER_MODES.QUICK_SWITCH, BOTTOM_WIDGET_FOOTER_MODES.TOGGlE];
      const isAtTheBottom = this.isAtBottom && !dontHide.includes(this.bottomWidgetFooterMode);
      return isAtTheBottom || !this.visible;
    },
    nextButtonTitle() {
      return this.tradeTypeText;
    },
    nextButtonClassModifiers() {
      return {
        'purchase-offer-sushi-mobile-bar__preview-button': true,
        'purchase-offer-sushi-mobile-bar__preview-button--yes': this.isYesType && !this.nextButtonDisabled,
        'purchase-offer-sushi-mobile-bar__preview-button--no': !this.isYesType && !this.nextButtonDisabled,
        'purchase-offer-sushi-mobile-bar__preview-button--disabled': this.nextButtonDisabled,
      };
    },
    isExpandedBetslipActive() {
      return this.bottomWidgetFooterMode === BOTTOM_WIDGET_FOOTER_MODES.BETSLIP
        && this.bottomBetslipExtended;
    },
  },
  watch: {
    isExpandedBetslipActive() {
      this.updateExpandedBetslipScrollLock();
    },
  },
  mounted() {
    this._scrollTarget = this.getScrollParent(this.$el) || window;

    if ('IntersectionObserver' in window) {
      this.initIntersectionObserver();
    } else {
      const target = this._scrollTarget === document ? window : this._scrollTarget;
      if (target && target.addEventListener) {
        target.addEventListener('scroll', this.handleScroll, { passive: true });
      }
      window.addEventListener('resize', this.handleScroll);
      window.addEventListener('orientationchange', this.handleScroll);
    }

    this.$nextTick(() => {
      this.handleScroll();
      this.updateExpandedBetslipScrollLock();
    });
  },
  beforeDestroy() {
    this.releaseExpandedBetslipScrollLock();
    if (this._observer) {
      this._observer.disconnect();
    }
    const target = this._scrollTarget === document ? window : this._scrollTarget;
    if (target && target.removeEventListener) {
      target.removeEventListener('scroll', this.handleScroll);
    }
    window.removeEventListener('resize', this.handleScroll);
    window.removeEventListener('orientationchange', this.handleScroll);
  },
  methods: {
    ...mapActions('trade', [
      'setTradeOptions', 'toggleTradeOperation', 'toggleBottomBetslipMode',
      'setBottomWidgetFooterMode', 'setBottomWidgetFooterModeContractsSection',
    ]),
    ...mapActions('popup', ['setCurrentPopup']),
    ...mapActions('market', ['pushSessionHistoryContract']),
    isPersistentFooterMode(footerMode) {
      return [
        BOTTOM_WIDGET_FOOTER_MODES.BETSLIP,
        BOTTOM_WIDGET_FOOTER_MODES.PINNED,
        BOTTOM_WIDGET_FOOTER_MODES.QUICK_SWITCH,
      ].includes(footerMode);
    },
    getExpandedBetslipFixedOffset() {
      const stickyTitle = document.querySelector('.page-market-detail-sushi__title');

      if (!stickyTitle || window.pageYOffset <= 1) {
        return 0;
      }

      const stickyTitleRect = stickyTitle.getBoundingClientRect();
      const stickyTitleStyle = window.getComputedStyle(stickyTitle);
      const isStickyTitleVisible = stickyTitleRect.height > 0 &&
        stickyTitleRect.bottom > stickyTitleRect.top;
      const isStickyTitlePinned = stickyTitle.classList.contains('page-market-detail-sushi__title--is-sticky') ||
        stickyTitleStyle.position === 'sticky' ||
        stickyTitleStyle.position === '-webkit-sticky' ||
        stickyTitleStyle.position === 'fixed';

      return isStickyTitleVisible && isStickyTitlePinned
        ? Math.round(stickyTitleRect.height)
        : 0;
    },
    switchTo(footerMode) {
      this.setBottomWidgetFooterMode(footerMode);
      if (!this.navigatedFromContractsSection && this.isPersistentFooterMode(footerMode)) {
        this.setBottomWidgetFooterModeContractsSection(footerMode);
      }
    },
    updateExpandedBetslipScrollLock() {
      if (this.isExpandedBetslipActive && !this._expandedBetslipScrollLocked) {
        lockScroll({ forceFixed: true, fixedOffset: this.getExpandedBetslipFixedOffset() });
        this._expandedBetslipScrollLocked = true;
      } else if (!this.isExpandedBetslipActive) {
        this.releaseExpandedBetslipScrollLock();
      }
    },
    releaseExpandedBetslipScrollLock() {
      if (!this._expandedBetslipScrollLocked) return;
      unlockScroll();
      this._expandedBetslipScrollLocked = false;
    },
    initIntersectionObserver() {
      const sentinel = document.querySelector('.footer__bottom');

      if (!sentinel) {
        // Fallback to scroll listener if sentinel not found in DOM yet
        setTimeout(() => {
          const retrySentinel = document.querySelector('.footer__bottom');
          if (retrySentinel) {
            this.setupObserver(retrySentinel);
          } else {
            const target = this._scrollTarget === document ? window : this._scrollTarget;
            target.addEventListener('scroll', this.handleScroll, { passive: true });
          }
        }, 1000);
        return;
      }

      this.setupObserver(sentinel);
    },

    setupObserver(element) {
      this._observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          this.isAtBottom = entry.isIntersecting;
        });
      }, {
        root: null,
        rootMargin: '0px 0px 50px 0px',
        threshold: 0,
      });

      this._observer.observe(element);
    },

    getScrollParent(el) {
      if (!el) return document.scrollingElement || document.documentElement || document.body;
      let node = el;
      while (node && node !== document.body) {
        const style = window.getComputedStyle(node);
        const overflowY = style.overflowY;
        const canScroll = (overflowY === 'auto' || overflowY === 'scroll') && (node.scrollHeight > node.clientHeight + 1);
        if (canScroll) return node;
        node = node.parentElement;
      }
      return document.scrollingElement || document.documentElement || document.body;
    },

    onTouchStartForSwipeDown(e) {
      this.extDragStartY = e.touches[0].clientY;
      this.extDragAtTop = this.getInnerScrollTop(e.target) === 0;
    },
    onTouchEndForSwipeDown(e) {
      if (!this.extDragAtTop || !this.bottomBetslipExtended) return;
      const delta = e.changedTouches[0].clientY - this.extDragStartY;
      if (delta > 60) {
        this.toggleBottomBetslipMode();
      }
    },
    getInnerScrollTop(el) {
      let node = el;
      while (node && node !== this.$el) {
        const ov = window.getComputedStyle(node).overflowY;
        const isScrollable = (ov === 'auto' || ov === 'scroll')
          && node.scrollHeight > node.clientHeight + 1;
        if (isScrollable) {
          return node.scrollTop;
        }
        node = node.parentElement;
      }
      return 0;
    },
    handleScroll() {
      const target = this._scrollTarget || window;

      const isWindowTarget = target === window
        || target === document
        || target === document.body
        || target === document.documentElement;

      if (isWindowTarget) {
        const doc = document.documentElement;
        const body = document.body;
        const scrollTop = (typeof window.pageYOffset === 'number' ? window.pageYOffset : 0) || (doc && doc.scrollTop) || (body && body.scrollTop) || 0;
        const clientHeight = (typeof window.innerHeight === 'number' ? window.innerHeight : 0) || (doc && doc.clientHeight) || 0;
        const scrollHeight = Math.max(
          (doc && doc.scrollHeight) || 0,
          (body && body.scrollHeight) || 0,
          (doc && doc.offsetHeight) || 0,
          (body && body.offsetHeight) || 0,
        );
        this.isAtBottom = scrollTop + clientHeight >= scrollHeight - 5;
      } else {
        const el = target;
        const scrollTop = el.scrollTop;
        const clientHeight = el.clientHeight;
        const scrollHeight = el.scrollHeight;
        this.isAtBottom = scrollTop + clientHeight >= scrollHeight - 5;
      }
    },
  },
  created() {
    if (this.navigatedFromContractsSection) {
      const contractsSectionMode = this.isPersistentFooterMode(this.bottomWidgetFooterMode)
        ? this.bottomWidgetFooterMode
        : this.bottomWidgetFooterModeContractsSection;

      this.setBottomWidgetFooterModeContractsSection(contractsSectionMode);
      this.setBottomWidgetFooterMode(BOTTOM_WIDGET_FOOTER_MODES.QUICK_SWITCH);
      this.$nextTick(() => {
        this.visible = true;
      });
    } else {
      this.visible = true;
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/purchase/sushi/purchase-offer-sushi-mobile-bar/purchase-offer-sushi-mobile-bar.js